import { useFlag } from '@b-stock/fe-core/bstock-next/helpers'

import { FeatureFlags } from '@/helpers/featureFlags'

/** True when parcel quotes are on for everyone, or the seller is on the parcel exception list. */
export const useParcelQuotesEnabled = (sellerAccountId: string): boolean => {
  const parcelQuotesEnabled = useFlag(FeatureFlags.ENABLE_PARCEL_QUOTES)
  const parcelQuotesExceptionList = useFlag(
    FeatureFlags.PARCEL_QUOTES_EXCEPTION_LIST
  )
  return (
    parcelQuotesEnabled ||
    (Array.isArray(parcelQuotesExceptionList) &&
      parcelQuotesExceptionList.includes(sellerAccountId))
  )
}
